module.exports = __webpack_public_path__ + "img/product-preview-73.576f80b.png";